export const onDropNodeCallback =
  ({
    reactFlowWrapper,
    reactFlowInstance,
    setNodes,
    setSelectedNodeId,
    getId,
    setModifications,
    setIsPanelOpened
  }) =>
    (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData("application/reactflow");

      // check if the dropped element is valid
      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left - 150,
        y: event.clientY - reactFlowBounds.top,
      });
      var data;
      if (type === "message") {
        data = {
          body: "",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "template") {
        data = {
          whatsappTemplateName: "",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "consent") {
        data = {
          type: "optin",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "wait") {
        data = {
          type: "",
          duration: "0",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "tag") {
        data = {
          tag: "",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "webhook") {
        data = {
          type: "webhook",
          webhookId: "",
          name: "",
          method: "",
          destinationUrl: "",
          headers: [{ key: "", value: "" }],
          body: `{"phone": "{{ contact.userPhoneNumber }}"}`,
          pathParams: [{ key: "", value: "" }],
          queryParams: [{ key: "", value: "" }],
          configResponse: [{ key: "", value: "" }],
          clickNode: setSelectedNodeId,
        };
      } else if (type === "ai") {
        data = {
          companyContext:
            "A WhatsApp chat between a (potential) customer and an assistant from the AAA brand.",
          assistantContext:
            "You are a friendly and dedicated assistant of customer support. You can help the customers by answering their questions.",
          answerStyle:
            "Address the person you're talking to in a calm, enthusiastic tone of voice.\nUse the plural form.\nIf the customer thanks us or is happy, greet him with only an emoji.\nIf the user is only small talking, just answer with an emoji.",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "note") {
        data = {
          note: "",
          clickNode: setSelectedNodeId,
        };
      } else if (type === "condition") {
        data = {
          type: "condition",
          property: null,
          operator: null,
          valueBoolean: null,
          valueStartingPeriodInMinutes: null,
          valueType: null,
          valueTag: null,
          clickNode: setSelectedNodeId,
        };
      }

      const newNode = {
        id: getId(),
        type,
        position,
        data,
        selected: true
      };

      setNodes((nds) => nds
        .map(node => ({ ...node, selected: false }))
        .concat(newNode));
      setModifications(true);
      setSelectedNodeId(newNode.id);
      setIsPanelOpened(true);
    };
